// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__dEv6p","calendarButtons":"ClockData_calendarButtons__1GbSA"};